<template>
    <el-row :gutter="20">
        <el-col :span="4" class="colleft">
            <div class="toptitle">关于我们</div>
            <div style="height: 20px;background-color: #ffff;width: 100%;"></div>
            <el-menu :default-active="defaultIndex" class="el-menu-vertical-demo"  background-color="#FFFFFF"  @select="handleSelect"
                text-color="#000000" active-text-color="#52536f">
                <el-menu-item index="1">
                    <i class="el-icon-lx-global"></i>
                    <span slot="title">公司介绍</span>
                </el-menu-item>
                <el-menu-item index="2">
                    <i class="el-icon-lx-news"></i>
                    <span slot="title">网站公告</span>
                </el-menu-item>
            </el-menu>

        </el-col>
        <el-col :span="20">
            <el-card shadow="always" class="colright">
                <Company v-if="page == '1'"></Company>
                <NoticeList v-if="page == '2'&&!(id>0)"></NoticeList>
                <Notice v-if="id>0"></Notice>
              
            </el-card>

        </el-col>

    </el-row>

</template>

<script>

import bus from "../common/bus.js";
import guide1 from './GUIDE/Guide1.vue';
import guide2 from './GUIDE/Guide2.vue';
import Introduction from './GUIDE/Introduction.vue';
import Customer from './GUIDE/Customer.vue';
import Company from './About/Company.vue';
import NoticeList from './About/NoticeList.vue';
import Notice from './Notice.vue';
export default {
   
    data() {
        return {
            defaultIndex:'1',
            page: '1',
            id:0,
        };
    },
    components: {
        NoticeList,Company,Notice
    },
    computed: {

    },
    created() {

    },
    activated() {

    },
    deactivated() {

    },
    watch: {
        // 监听路由对象中的查询参数部分
        '$route.query': {
            immediate: true, // 启用组件实例化时立即触发
            handler(newQuery, oldQuery) {
                // 这里处理查询参数变化的逻辑
                console.log('查询参数变化了:', newQuery, oldQuery);
                let index = this.$route.query.index;
                if (index) {
                    this.page = index;
                    this.defaultIndex = index;
                    this.id=this.$route.query.id;
                }
                console.log(index);
                // 例如，你可以在这里根据查询参数重新获取数据
            }

        }
    },
    methods: {
        handleSelect(key, keyPath) {
            this.page = key;
            console.log(keyPath);
            if(this.page=='2')
            {
                this.$router.push('/about?index=2');
            }
        }
    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.colleft {

    border-radius: 5px !important;
    height: 100%;
    background-color: #ff8800;
    border: 2px solid #ff8800;
    box-shadow: 2px 2px 2px 2px #d7d7d7;
    padding: 0px !important;
    padding-bottom: 20px !important;

}

.toptitle {
    text-align: center;
    font-size: 22px;
    margin-top: 20px;
    font-weight: 600px;
    color: #ffffff;
    height: 50px;
}

.el-menu-vertical-demo {
    margin-top: 0px;
}

.el-menu-item.is-active {
    border-bottom: 3px solid #52536f;
    background-color: #52536f !important;
    color: #ffffff !important;
    border-bottom: 0px solid #52536f;
}

.menutitle.is-active {
    border-bottom: 3px solid #52536f;
    background-color: #52536f !important;
    color: #ffffff !important;
    border-bottom: 0px solid #52536f;
}

.el-menu-item {
    font-size: 20px;
    color: #737373;
}

.el-icon-news {
    font-size: 20px;
    color: #737373;
}

.submenu {
    font-size: 20px;
    color: #737373;
}

.colright {}
</style>
